var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4272 19.2146C14.2372 19.2146 14.0472 19.1446 13.8972 18.9946C13.6072 18.7046 13.6072 18.2246 13.8972 17.9346L19.4372 12.3946L13.8972 6.85465C13.6072 6.56465 13.6072 6.08465 13.8972 5.79465C14.1872 5.50465 14.6672 5.50465 14.9572 5.79465L21.0272 11.8646C21.3172 12.1546 21.3172 12.6346 21.0272 12.9246L14.9572 18.9946C14.8072 19.1446 14.6172 19.2146 14.4272 19.2146Z",
    fill: "#FDB62F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.33 13.1445H3.5C3.09 13.1445 2.75 12.8045 2.75 12.3945C2.75 11.9845 3.09 11.6445 3.5 11.6445H20.33C20.74 11.6445 21.08 11.9845 21.08 12.3945C21.08 12.8045 20.74 13.1445 20.33 13.1445Z",
    fill: "#FDB62F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.210e2c058846587c959df576a3993b7d.svg";
export { ForwardRef as ReactComponent };